import { DragEvent } from 'react';
import { Box, BoxProps } from '@mui/material';

interface IFileDropWrapper extends BoxProps {
  disabled?: boolean;
  handleDragOver?: (e: DragEvent) => void;
  handleDragLeave?: (e: DragEvent) => void;
  handleDrop?: (e: DragEvent) => void;
}

const FileDropWrapper = ({
  disabled = false,
  handleDragOver,
  handleDragLeave,
  handleDrop,
  children,
  ...other
}: IFileDropWrapper) =>
  disabled ? (
    <Box data-testid='dropzone' {...other}>
      {children}
    </Box>
  ) : (
    <Box
      {...other}
      data-testid='dropzone'
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      {children}
    </Box>
  );

export default FileDropWrapper;
